import React from "react";

import Layout from "./src/components/layout/Layout";

import { getInitialLocale } from "./src/utils/i18n";

import './src/styles/globals.scss';

import {
  PrivacyProvider,
  PrivacyManager,
  googleAnalytics,
  PrivacyLocale
} from "./src/components/privacy";

import LoginAuth from "./src/components/login/LoginAuth";

const isProduction =
  process.env.GATSBY_ENV === "production";

const privacyConfig = {

  locale: "en" as PrivacyLocale,

  policyVersion: "1.0",
  cookiePolicyVersion: "1.0",

  services: [
    ...(isProduction
      ? [
          googleAnalytics({
            measurementId: process.env.GATSBY_GA_MEASUREMENT_ID!,
          }),
        ]
      : []),

    // googleMaps(),
    // youtube()
  ]
};


export const wrapPageElement = ({
  element,
}: any) => {

  return (
  <LoginAuth>
    <PrivacyProvider config={privacyConfig}>
      <Layout>
        {element}
      </Layout>
      <PrivacyManager/>
    </PrivacyProvider>
  </LoginAuth>
  );

};